import { Component, Input} from '@angular/core';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { Itinerary } from 'src/app/assabil-kernel/models/entities/master-data/itinerary-entity';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { BranchLovComponent } from '../../../control-tables/branch/branch-lov/branch-lov.component';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';


@Component({
    selector: 'itinerary-lov',
    templateUrl: './itinerary-lov.component.html',
    styleUrls: ['./itinerary-lov.component.scss']
})


export class ItineraryLovComponent extends GenericLovComponent {
  
    @Input() code         : string; 
    @Input() name         : string; 



    branch                 : Branch;
    itinerarys             : Itinerary[] = [];

    branchLovComponent    = BranchLovComponent;


    columns = [
        {  prop: 'itineraryCode',   name: 'Code'},
        {  prop: 'name',            name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<ItineraryLovComponent>,
    protected masterDataService  : MasterDataService) {
    super();
    this.entityName = "itinerary";
}
//----------------------------------------------------------------------
    

//----------------------------------------------------------------------
setParam(role : Role) {
    this.branch = role.branch;
};
//----------------------------------------------------------------------
  

//----------------------------------------------------------------------
loadData() {
    let branchCode : string;
    if (this.branch) branchCode = this.branch.branchCode;

    this.masterDataService.itinerarysGet(this.code, this.name, branchCode).then(result => {
        this.itinerarys = result;
        })
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
closeModal(row : Branch){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
